<template>

  <v-container fluid px-1>

    <v-row v-show="this.totalChartsDisplayed.every(x => x === false) === true & this.dataLoaded === true">
      <v-col>
        <app-highlighted-text> {{ $t('charts.noCharts') }}</app-highlighted-text>
      </v-col>
    </v-row>

    <v-row v-show="!(this.totalChartsDisplayed.every(x => x === false) === true) && isFungusApp">
      <v-col>
        <app-highlighted-text><b>{{ $t('charts.introductionTitle') }} </b> <br> {{ $t('charts.introduction') }}
        </app-highlighted-text>
      </v-col>
    </v-row>

    <v-row>
      <v-col
          cols="12"
          xl="6"
          lg=8
          md="10"
          sm="12"
          xs="12"

          offset-xl="0"
          offset-lg="2"
          offset-md="1"
          offset-sm="0"
          offset-xs="0"

          v-for="chart in charts.filter((chart) => { return chart.config.includes(application) && chart.visible})"
          :key="chart.id"
      >
        <v-card style="background-color: white"
                elevation="30"
                outlined
        >
          <!-- Note: chartjs can only take hardcoded height and width props. -->
          <!-- For dynamic resizing with multiple labels in barcharts, the height is re-calculated:  -->
          <!-- no. of labels x 20px + 70px for chart header -->
          <div v-if="chart.id==='myko'">
            <v-icon right @click="showMykoLegend=true">mdi-information</v-icon>
            <app-popup
                :title="$t('charts.mycorrhiza')"
                :text="$t('charts.mykoText')"
                :showPopup.sync="showMykoLegend"
                @cancel="showMykoLegend=false"
            />
          </div>

          <div v-if="chart.id==='fine'">
            <v-icon right @click="showFineFUNGUSLegend=true">mdi-information</v-icon>
            <app-popup
                :title="$t('charts.categoriesFor')+$t('charts.fine')"
                :text="$t('charts.fineText')"
                :showPopup.sync="showFineFUNGUSLegend"
                @cancel="showFineFUNGUSLegend=false"
            />
          </div>

          <div v-if="chart.id==='delarze'">
            <v-icon right @click="showDelarzeLegend=true">mdi-information</v-icon>
            <app-popup
                :title="$t('charts.bibliographyDelarzeTitle')"
                :text="$t('charts.bibliographyDelarzeText')"
                :showPopup.sync="showDelarzeLegend"
                @cancel="showDelarzeLegend=false"
            />
          </div>

          <horizontal-bar-chart
              v-if="chart.chartType === 'horizontal' && chart.id !== 'altitude'"
              :chart-data="{labels: chart.labels, datasets: [chart.dataset]}"
              :options="chart.options"
              :height="chart.labels.length*20+70 < 420 ? 320 : chart.labels.length*20+70"
              class="app-chart"
          />


          <horizontal-bar-chart
              v-if="chart.chartType === 'horizontal' && chart.id === 'altitude'"
              :chart-data="{labels: chart.labels, datasets: [chart.dataset]}"
              :options="chart.options"
              :height="chart.labels.length*20+70 < 420 ? 320 : chart.labels.length*10+70"
              class="app-chart"
          />


          <vertical-bar-chart
              v-if="chart.chartType === 'vertical'"
              :chart-data="{labels: chart.labels, datasets: [chart.dataset]}"
              :options="chart.options"
              class="app-chart"
          />

          <div v-if="chart.id==='woodDistinction'">
            <v-icon right @click="showWoodDistinctionLegend=true">mdi-information</v-icon>
            <app-popup
                :title="$t('charts.categoriesFor')+$t('charts.wooddistinction')"
                :text="$t('charts.woodDistinctionText')"
                :showPopup.sync="showWoodDistinctionLegend"
                @cancel="showWoodDistinctionLegend=false"
            />
          </div>

          <div v-if="chart.id==='coarseFUNGUS'">
            <v-icon right @click="showCoarseFUNGUSLegend=true">mdi-information</v-icon>
            <app-popup
                :title="$t('charts.categoriesFor')+$t('charts.coarse')"
                :text="$t('charts.coarseText')"
                :showPopup.sync="showCoarseFUNGUSLegend"
                @cancel="showCoarseFUNGUSLegend=false"
            />
          </div>

          <div v-if="chart.id==='woodQuality'">
            <v-icon right @click="showWoodQualityLegend=true">mdi-information</v-icon>
            <app-popup
                :title="$t('charts.categoriesFor')+$t('charts.woodquality')"
                :text="$t('charts.woodqualityText')"
                :showPopup.sync="showWoodQualityLegend"
                @cancel="showWoodQualityLegend=false"
            />
          </div>

          <pie-chart
              v-if="chart.chartType === 'pie'"
              :chart-data="{labels: chart.labels, datasets: [chart.dataset]}"
              :options="chart.options"
              class="app-chart"
              :height="chart.labels.length*20+70 < 420 ? 320 : chart.labels.length*10+70"

          />

          <polar-area-chart
              v-if="chart.chartType === 'polar'"
              :chart-data="{labels: chart.labels, datasets: [chart.dataset]}"
              :options="chart.options"
              class="app-chart"
          />

          <line-chart
              v-if="chart.chartType === 'line'"
              :chart-data="{labels: chart.labels, datasets: [chart.dataset]}"
              :options="chart.options"
              class="app-chart"
          />
        </v-card>
      </v-col>

    </v-row>

    <v-row v-show="this.dataLoaded === false">
      <v-col justify="center" align="center">
        <v-progress-circular
            indeterminate
            color="primary"
            size="44"
            width="6"

        ></v-progress-circular>
      </v-col>
    </v-row>

  </v-container>


</template>

<script>

import HorizontalBarChart from '../ChartTemplates/HorizontalBarChart'
import LineChart from '../ChartTemplates/LineChart'
import PieChart from '../ChartTemplates/PieChart'
import PolarAreaChart from '../ChartTemplates/PolarAreaChart'
import VerticalBarChart from '../ChartTemplates/VerticalBarChart'
import AppPopup from '../AppComponents/AppPopupDialog'
import AppHighlightedText from '../AppComponents/AppHighlightedText'
import axios from 'axios'
import i18n from '../../plugins/i18n'
import {API_ERROR_MESSAGE, COLOR_SCHEME} from '../../data/constants'
import {diagramUrl} from '../../data/app-data'
import store from '../../store'
import 'core-js/stable'
import 'regenerator-runtime/runtime'

export default {
  name: 'ChartsStatistics',
  components: {
    LineChart,
    HorizontalBarChart,
    VerticalBarChart,
    PieChart,
    PolarAreaChart,
    AppPopup,
    AppHighlightedText
  },
  data() {
    return {
      app_lightgreen: COLOR_SCHEME.app_lightyellow,
      showWoodDistinctionLegend: false,
      showCoarseFUNGUSLegend: false,
      showFineFUNGUSLegend: false,
      showWoodQualityLegend: false,
      showDelarzeLegend: false,
      showMykoLegend: false,
      dataLoaded: false,
      totalChartsDisplayed: [],
      charts: [{
        id: 'phenology',
        config: 'FUNGUS',
        title: i18n.t('charts.phenology'),
        api: diagramUrl.diagramByMonth,
        visible: false,
        chartType: 'horizontal',
        yearRange: {min: store.state.min, max: store.state.max},
        color: COLOR_SCHEME.app_dark_red,
        labels: [i18n.t('charts.january'), i18n.t('charts.february'), i18n.t('charts.march'), i18n.t('charts.april'), i18n.t('charts.may'), i18n.t('charts.june'), i18n.t('charts.july'), i18n.t('charts.august'), i18n.t('charts.september'), i18n.t('charts.october'), i18n.t('charts.november'), i18n.t('charts.december')],
        dataset: {},
        options: this.getChartOptions(true, false, 'horizontal')
      },
        // {
        //     id: 'phenologyAll',
        //     config: 'FUNGUS',
        //     title: i18n.t('charts.phenology'),
        //     api: diagramUrl.diagramByMonth,
        //     visible: false,
        //     chartType: 'horizontal',
        //     yearRange: {min: TIME_RANGE.min, max: TIME_RANGE.max},
        //     color: COLOR_SCHEME.app_dark_yellow,
        //     labels: [i18n.t('charts.january'), i18n.t('charts.february'), i18n.t('charts.march'), i18n.t('charts.april'), i18n.t('charts.may'), i18n.t('charts.june'), i18n.t('charts.july'), i18n.t('charts.august'), i18n.t('charts.september'), i18n.t('charts.october'), i18n.t('charts.november'), i18n.t('charts.december')],
        //     dataset: {},
        //     options: this.getChartOptions(true, false)
        // },
        {
          id: 'ecotype',
          config: 'LICHEN',
          title: i18n.t('charts.ecotype'),
          api: diagramUrl.diagramByEcotype,
          visible: false,
          chartType: 'horizontal',
          yearRange: {min: store.state.min, max: store.state.max},
          color: COLOR_SCHEME.app_dark_red,
          labels: [],
          dataset: {},
          options: this.getChartOptions(false, true, 'horizontal')
        },
        {
          id: 'altitude',
          config: 'LICHEN && FUNGUS',
          title: i18n.t('charts.altitude'),
          api: diagramUrl.diagramByAltitude,
          visible: false,
          chartType: 'horizontal',
          yearRange: {min: store.state.min, max: store.state.max},
          color: COLOR_SCHEME.app_dark_red,
          labels: [' > 2000m ', '1600 - 2000m', '1000 - 1600m ', '600 - 1000m', '<600'],
          dataset: {},
          options: this.getChartOptions(false, true, 'horizontal')
        },
        // {
        //     id: 'altitudeAll',
        //     config: 'LICHEN && FUNGUS',
        //     title: i18n.t('charts.altitude'),
        //     api: diagramUrl.diagramByAltitude,
        //     visible: false,
        //     chartType: 'horizontal',
        //     yearRange: {min: TIME_RANGE.min, max: TIME_RANGE.max},
        //     color: COLOR_SCHEME.app_dark_yellow,
        //     labels: [' > 2000m ', '1600 - 2000m', '1000 - 1600m ', '600 - 1000m', '<600' ],
        //     dataset: {},
        //     options: this.getChartOptions(false, true)
        // },
        {
          id: 'coarseFUNGUS',
          config: 'FUNGUS',
          title: i18n.t('charts.coarse'),
          api: diagramUrl.diagramBySubstrateCoarse,
          visible: false,
          chartType: 'pie',
          yearRange: {min: store.state.min, max: store.state.max},
          color: '',
          labels: [],
          dataset: {},
          options: this.getChartOptions(false, false, 'pie')
        },
        {
          id: 'coarseLICHEN',
          config: 'LICHEN',
          title: i18n.t('charts.coarseL'),
          api: diagramUrl.diagramBySubstrateCoarse,
          visible: false,
          chartType: 'horizontal',
          yearRange: {min: store.state.min, max: store.state.max},
          color: COLOR_SCHEME.app_dark_red,
          labels: [],
          dataset: {},
          options: this.getChartOptions(true, false, 'horizontal')
        },
        // {
        //     id: 'coarseAll',
        //     config: 'FUNGUS',
        //     title: i18n.t('charts.coarse'),
        //     api: diagramUrl.diagramBySubstrateCoarse,
        //     visible: false,
        //     chartType: 'pie',
        //     yearRange: {min: TIME_RANGE.min, max: TIME_RANGE.max},
        //     color: '',
        //     labels: [],
        //     dataset: {},
        //     options: this.getChartOptions(false, false)
        // },
        {
          id: 'fine',
          config: 'FUNGUS',
          title: i18n.t('charts.fine'),
          api: diagramUrl.diagramBySubstrateFine,
          visible: false,
          chartType: 'horizontal',
          yearRange: {min: store.state.min, max: store.state.max},
          color: COLOR_SCHEME.app_dark_red,
          labels: [],
          dataset: {},
          options: this.getChartOptions(true, false, 'horizontal')
        },
        // {
        //     id: 'fineAll',
        //     config: 'LICHEN && FUNGUS',
        //     title: i18n.t('charts.fine'),
        //     api: diagramUrl.diagramBySubstrateFine,
        //     visible: false,
        //     chartType: 'horizontal',
        //     yearRange: {min: TIME_RANGE.min, max: TIME_RANGE.max},
        //     color: COLOR_SCHEME.app_dark_yellow,
        //     labels: [],
        //     dataset: {},
        //     options: this.getChartOptions(true, false)
        // },


        // {
        //     id: 'ecotypeAll',
        //     config: 'LICHEN',
        //     title: i18n.t('charts.ecotype'),
        //     api: diagramUrl.diagramByEcotype,
        //     visible: false,
        //     chartType: 'pie',
        //     yearRange: {min: TIME_RANGE.min, max: TIME_RANGE.max},
        //     color: COLOR_SCHEME.app_dark_yellow,
        //     labels: [],
        //     dataset: {},
        //     options: this.getChartOptions(false, true)
        // },

        // hostfungus: currently -> not enough data to display relevant charts
        // {
        //     id: 'hostFungus',
        //     config: 'FUNGUS',
        //     title: i18n.t('charts.hostfungus'),
        //     api: diagramUrl.diagramByHostFungus,
        //     visible: false,
        //     chartType: 'polar',
        //     yearRange: {min: store.state.min, max: store.state.max},
        //     color: '',
        //     labels: [],
        //     dataset: {},
        //     options: this.getChartOptions(false, false)
        // },
        // {
        //     id: 'hostFungusAll',
        //     config: 'FUNGUS',
        //     title: i18n.t('charts.hostfungus'),
        //     api: diagramUrl.diagramByHostFungus,
        //     visible: false,
        //     chartType: 'polar',
        //     yearRange: {min: TIME_RANGE.min, max: TIME_RANGE.max},
        //     color: '',
        //     labels: [],
        //     dataset: {},
        //     options: this.getChartOptions(false, false)
        // },

        {
          id: 'hostPlant',
          config: 'FUNGUS',
          title: i18n.t('charts.hostplant'),
          api: diagramUrl.diagramByHostPlant,
          visible: false,
          chartType: 'horizontal',
          yearRange: {min: store.state.min, max: store.state.max},
          color: COLOR_SCHEME.app_dark_red,
          labels: [],
          dataset: {},
          options: this.getChartOptions(false, false, 'horizontal')
        },
        // {
        //     id: 'hostPlantAll',
        //     config: 'FUNGUS',
        //     title: i18n.t('charts.hostplant'),
        //     api: diagramUrl.diagramByHostPlant,
        //     visible: false,
        //     chartType: 'pie',
        //     yearRange: {min: TIME_RANGE.min, max: TIME_RANGE.max},
        //     color: '',
        //     labels: [],
        //     dataset: {},
        //     options: this.getChartOptions(false, false)
        // },

        {
          id: 'woodQuality',
          config: 'FUNGUS',
          title: i18n.t('charts.woodquality'),
          api: diagramUrl.diagramByWoodQuality,
          visible: false,
          chartType: 'pie',
          yearRange: {min: store.state.min, max: store.state.max},
          color: '',
          labels: [],
          dataset: {},
          options: this.getChartOptions(false, false, 'pie')
        },
        // {
        //     id: 'woodQualityAll',
        //     config: 'FUNGUS',
        //     title: i18n.t('charts.woodquality'),
        //     api: diagramUrl.diagramByWoodQuality,
        //     visible: false,
        //     chartType: 'pie',
        //     yearRange: {min: TIME_RANGE.min, max: TIME_RANGE.max},
        //     color: '',
        //     labels: [],
        //     dataset: {},
        //     options: this.getChartOptions(false, false)
        // },


        {
          id: 'woodDistinction',
          config: 'FUNGUS',
          title: i18n.t('charts.wooddistinction'),
          api: diagramUrl.diagramByWoodDistinction,
          visible: false,
          chartType: 'pie',
          yearRange: {min: store.state.min, max: store.state.max},
          color: '',
          labels: [],
          dataset: {},
          options: this.getChartOptions(false, false, 'pie')
        },
        // {
        //     id: 'woodDistinctionAll',
        //     config: 'FUNGUS',
        //     title: i18n.t('charts.wooddistinction'),
        //     api: diagramUrl.diagramByWoodDistinction,
        //     visible: false,
        //     chartType: 'pie',
        //     yearRange: {min: TIME_RANGE.min, max: TIME_RANGE.max},
        //     color: '',
        //     labels: [],
        //     dataset: {},
        //     options: this.getChartOptions(false, false)
        // },

        {
          id: 'myko',
          config: 'FUNGUS',
          title: i18n.t('charts.mycorrhiza'),
          api: diagramUrl.diagramByMykoPartner,
          visible: false,
          chartType: 'horizontal',
          yearRange: {min: store.state.min, max: store.state.max},
          color: COLOR_SCHEME.app_dark_red,
          labels: [],
          dataset: {},
          options: this.getChartOptions(true, false, 'horizontal')
        },
        // {
        //     id: 'mykoAll',
        //     config: 'FUNGUS',
        //     title: i18n.t('charts.mycorrhiza'),
        //     api: diagramUrl.diagramByMykoPartner,
        //     visible: false,
        //     chartType: 'horizontal',
        //     yearRange: {min: TIME_RANGE.min, max: TIME_RANGE.max},
        //     color: COLOR_SCHEME.app_dark_yellow,
        //     labels: [],
        //     dataset: {},
        //     options: this.getChartOptions(true, false)
        // },

        // {
        //     id: 'delarzeMini',
        //     config: 'LICHEN && FUNGUS',
        //     title: i18n.t('charts.delarze'),
        //     api: diagramUrl.diagramByDelarzeMini,
        //     visible: false,
        //     chartType: 'horizontal',
        //     yearRange: {min: store.state.min, max: store.state.max},
        //     color: COLOR_SCHEME.app_dark_red,
        //     labels: [],
        //     dataset: {},
        //     options: this.getChartOptions(true, false)
        // },
        // {
        //     id: 'delarzeMiniAll',
        //     config: 'LICHEN && FUNGUS',
        //     title: i18n.t('charts.delarze'),
        //     api: diagramUrl.diagramByDelarzeMini,
        //     visible: false,
        //     chartType: 'horizontal',
        //     yearRange: {min: TIME_RANGE.min, max: TIME_RANGE.max},
        //     color: COLOR_SCHEME.app_dark_yellow,
        //     labels: [],
        //     dataset: {},
        //     options: this.getChartOptions(true, false)
        // },

        {
          id: 'delarze',
          config: 'LICHEN && FUNGUS',
          title: i18n.t('charts.delarze'),
          api: diagramUrl.diagramByDelarze,
          visible: false,
          chartType: 'horizontal',
          yearRange: {min: store.state.min, max: store.state.max},
          color: COLOR_SCHEME.app_dark_red,
          labels: [],
          dataset: {},
          options: this.getChartOptions(true, false, 'horizontal')
        },
        // {
        //     id: 'delarzeAll',
        //     config: 'LICHEN && FUNGUS',
        //     title: i18n.t('charts.delarze'),
        //     api: diagramUrl.diagramByDelarze,
        //     visible: false,
        //     chartType: 'horizontal',
        //     yearRange: {min: TIME_RANGE.min, max: TIME_RANGE.max},
        //     color: COLOR_SCHEME.app_dark_yellow,
        //     labels: [],
        //     dataset: {},
        //     options: this.getChartOptions(true, false)
        // }
      ]
    }
  },
  computed: {
    taxonId() {
      return this.$store.state.taxonId
    },
    timespan() {
      return this.$store.state.yearRange.min + '' + this.$store.state.yearRange.max
    },
    lang() {
      return i18n.locale
    },
    application() {
      return this.$store.getters.application
    },
    isFungusApp() {
      return this.$store.getters.isFungusApp
    },
    versionYear() {
      return this.isFungusApp ? 1999 : 2008
    }
  },

  watch: {
    taxonId() {
      this.createCharts()
    },
    timespan() {
      this.createCharts()
    },
    lang() {
      this.createCharts()
    },
    application() {
      this.createCharts()
    }
  },

  methods: {

    getRandomColors(n) {
      // let colors = ['#003f5c', '#2f4b7c', '#665191', '#a05195', '#d45087', '#f95d6a', '#ff7c43', '#ffa600','#0b34ba', '#1397f9', '#50adb9', '#14d542', '#11ccb0', '#ebdb34', '#046fe1', '#161bab']
      let colors = ['#33a8c7ff', '#52e3e1ff', '#a0e426ff', '#fdf148ff', '#ffab00ff', '#f77976ff', '#f050aeff', '#d883ffff', '#9336fdff']
      while (colors.length < n) {
        do {
          var color = Math.floor((Math.random() * 2000000) + 1)
        } while (colors.indexOf(color) >= 0)
        colors.push('#' + ('000000' + color.toString(16)).slice(-6))
      }
      return colors
    },

    reorderArray(array, index, value) {
      // check if not -1 or undefined
      if (~index && typeof index !== 'undefined') {
        array.push(value)
        array.splice(index, 1)
      }
      return array
    },

    getLabels(data) {
      let labels = data.map(entry => entry.label.trim())
      let index = labels.indexOf('keine Angabe')
      return [this.reorderArray(labels, index, i18n.t('charts.notSpecified')), index]
    },

    getCounts(data, index, i = null, setCallback = false) {
      let absoluteCounts = data.map(entry => Number(entry.count))

      // use percentages for better interpretability of charts
      let sum = absoluteCounts.reduce((a, b) => a + b, 0)
      // let percentages = absoluteCounts.map(entry => (entry / sum * 100).toFixed(1))
      // return this.reorderArray(percentages, index, percentages[index])

      if (setCallback) {
        this.charts[i].options.scales.xAxes[0].ticks.callback = function (value) {
          return (value / sum * 100).toFixed(0) + '%'
        }
      }


      return this.reorderArray(absoluteCounts, index, absoluteCounts[index])
    },

    buildDataSet(label, color, dataset) {
      return {
        label: label,
        backgroundColor: color,
        hoverBorderColor: this.app_lightgreen,
        hoverBorderWidth: 4,
        minBarLength: 1.5,
        data: dataset
      }
    },

    getChartOptions(skipX, skipY, chartType) {
      return {
        title: {
          display: true,
          text: ''
        },
        legend: {
          display: chartType === 'pie'
        },
        animation: {
          duration: 0
        },
        hover: {
          animationDuration: 0
        },
        responsiveAnimationDuration: 0,
        tooltips: {
          intersect: false,

          mode: 'label',
          callbacks: {
            label: function (tooltipItem, data) {
              const add = (a, b) =>
                  Number(a) + Number(b)
              const sum = data['datasets'][0]['data'].reduce(add)

              if (chartType === 'pie') {
                return data.labels[tooltipItem['index']] + ': ' + data.datasets[0].data[tooltipItem['index']] + '  (' + (data.datasets[0].data[tooltipItem['index']] / sum * 100).toFixed(1) + '%)'
              } else {
                return data['datasets'][0]['data'][tooltipItem['index']] + '  (' + (data.datasets[0].data[tooltipItem['index']] / sum * 100).toFixed(1) + '%)'

              }
            }
          }
        },
        scales: {
          xAxes: [{
            ticks: {
              autoSkip: skipX,
              beginAtZero: true,
              callback: function (value) {
                return value + '%'
              }
            },
            scaleLabel: {
              display: true,
              labelString: i18n.t('charts.scaleLabel')
            }
          }],
          yAxes: [{
            ticks: {
              autoSkip: skipY,
              beginAtZero: true
            }
          }],
        },
        responsive: true,
        showTooltips: true,
        maintainAspectRatio: false
      }
    },

    getChartData(queryURL, i) {
      try {
        return axios.get(queryURL)

      } catch (error) {
        console.log(API_ERROR_MESSAGE, error)
        this.charts[i].visible = false
      }

    },

    async createCharts() {
      if (this.taxonId !== null) {
        this.totalChartsDisplayed = []
        for (let i = 0; i < this.charts.length; i++) {

          this.charts[i].yearRange.min = this.$store.state.yearRange.min
          this.charts[i].yearRange.max = this.$store.state.yearRange.max
          this.charts[i].options.title.text = this.charts[i].title + i18n.t('charts.fortimespan') + this.$store.state.yearRange.min + ' - ' + this.$store.state.yearRange.max
          if (this.charts[i].config.includes(this.application)) {
            let queryURL = this.charts[i].id === 'delarze' ? this.charts[i].api + this.taxonId + '?startyear=' + this.charts[i].yearRange.min + '&endyear=' + this.charts[i].yearRange.max + '&lang=' + i18n.locale + '&version=' + this.versionYear : this.charts[i].api + this.taxonId + '?startyear=' + this.charts[i].yearRange.min + '&endyear=' + this.charts[i].yearRange.max + '&lang=' + i18n.locale
            const result = await this.getChartData(queryURL, i)

            // hide chart if no data available for display or if only the counts for "keine Angabe" label are present
            // the complete display logic for substrate (fine), host plant, wood quality and wood distinction
            // in dependence of substrate coarse is integrated in the SQL queries, eg. ObservationHibernateDAO.java
            let totalResults = result.data.length
            this.charts[i].visible = totalResults !== 0 && !(result.data.every(x => x.count === '0') === true) && !(totalResults === 1 && result.data[0].label.startsWith('keine Angabe'))
            this.totalChartsDisplayed.push(this.charts[i].visible)

            // initialize undefined index for flexible label reordering in charts
            let ix
            if (!['phenology', 'altitude'].includes(this.charts[i].id)) {
              [this.charts[i].labels, ix] = this.getLabels(result.data)
            }

            if (['pie', 'polar'].includes(this.charts[i].chartType)) {
              this.charts[i].dataset = this.buildDataSet(i18n.t('charts.timespan') + this.charts[i].yearRange.min + ' - ' + this.charts[i].yearRange.max, this.getRandomColors(this.charts[i].labels.length), this.getCounts(result.data, ix))
              this.charts[i].options.scales = {} // reset scaling options for pie / polar charts to avoid doubled labels
            } else {
              this.charts[i].dataset = this.buildDataSet('', this.charts[i].color, this.getCounts(result.data, ix, i, true))
            }


          }
        }
        this.dataLoaded = true
      }
    }
  },

  created() {
    this.createCharts()
  }

}


</script>


<style scoped lang="scss">
@import '../../styles/variables';

.app-chart {
  font-family: $body-font-family;
}


</style>

